import React, { useState, useEffect } from "react"
import { DatePicker } from "components-design-system"
import "./styles.css"
import "./RJDatePicker.scss"
const RJDatePicker = (props) => {
  const [isDisabled, setDisabled] = useState(false)

  let { uiSchema } = props

  useEffect(() => {
    if (uiSchema) {
      if (uiSchema["ui:readonly"] || uiSchema["ui:disabled"]) {
        setDisabled(true)
      }
    }
  }, [props.value])

  return (
    <div className="rj-datepicker-container">
      <DatePicker
        className="rj-date-picker"
        value={props.value}
        disabled={isDisabled}
        onChange={props.onChange}
      />
    </div>
  )
}

export default RJDatePicker
